import { Component, Input, OnInit } from "@angular/core";
import { CONTACTDATA, PRIVACYNOTICEURL, SITEMAPURLS } from "src/shared/constants";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})

export class FooterComponent implements OnInit
{

  public sitemapUrls = SITEMAPURLS;
  public contactData = CONTACTDATA;
  public privacyNoticeUrl = PRIVACYNOTICEURL;
  todayDate : Date;

  constructor() {
    this.todayDate = new Date();
  }

  ngOnInit(): void { }

}
